import { PacotePromocionalDto } from "@/dtos/BuscarSorteioVigenteDto";
import { SelecaoCompraGiro } from "@/components/CompraRapidaGiro";

export interface NudgePacoteGiro {
    pacote: PacotePromocionalDto;
    mensagem: string;
}

export function encontrarPacotePorQuantidade(
    quantidade: number,
    pacotes: PacotePromocionalDto[]
): PacotePromocionalDto | undefined {
    return pacotes.find((p) => p.Qtd === quantidade);
}

export function criarSelecaoPacote(pacote: PacotePromocionalDto): SelecaoCompraGiro {
    return {
        modo: "pacote",
        idPacotePromocional: pacote.IdPacotePromocional,
        quantidade: pacote.Qtd,
        valor: pacote.Valor,
    };
}

export function criarSelecaoQuantidade(
    quantidade: number,
    valorUnitario: number
): SelecaoCompraGiro {
    return {
        modo: "quantidade",
        quantidade,
        valor: valorUnitario * quantidade,
    };
}

/**
 * Ajusta quantidade via +/−: permanece sempre em modo quantidade.
 * Pacote só entra por clique explícito (botão ou nudge).
 */
export function aplicarSelecaoPorQuantidade(
    novaQtd: number,
    qtdMinima: number,
    valorUnitario: number,
    _pacotes: PacotePromocionalDto[]
): {
    quantidade: number;
    pacote: PacotePromocionalDto | null;
    selecao: SelecaoCompraGiro;
} {
    const qtd = Math.max(qtdMinima, novaQtd);

    return {
        quantidade: qtd,
        pacote: null,
        selecao: criarSelecaoQuantidade(qtd, valorUnitario),
    };
}

/**
 * Nudge 0–±2: só em modo quantidade, com economia real (avulso > pacote).
 * Diff 0 sugere selecionar o pacote; ±1/±2 sugere ajustar quantidade.
 */
export function calcularNudgePacoteGiro(
    quantidade: number,
    valorUnitario: number,
    pacotes: PacotePromocionalDto[]
): NudgePacoteGiro | null {
    const valorAvulso = quantidade * valorUnitario;

    for (const pacote of pacotes) {
        const diff = Math.abs(pacote.Qtd - quantidade);
        if (diff > 2) {
            continue;
        }
        if (valorAvulso <= pacote.Valor) {
            continue;
        }

        if (diff === 0) {
            return {
                pacote,
                mensagem: "Selecione o pacote para pagar mais barato",
            };
        }

        const adicionar = pacote.Qtd - quantidade;
        const mensagem =
            adicionar > 0
                ? `Adicione mais ${adicionar} para pagar mais barato`
                : `Reduza ${Math.abs(adicionar)} para pagar mais barato`;

        return { pacote, mensagem };
    }

    return null;
}
